'use client'

import { Assets, MobileTopBar } from '@/components/organisms'
import { MobileCards } from '@/features/Cards/ui/MobileCards/MobileCards'
import { createTransactionsQueryOptions } from '@/features/Transactions/queries'
import { TotalBalanceSlider } from '@/features/Wallets/ui/TotalBalanceSlider/TotalBalanceSlider'
import { MobilePageTemplate } from '@/components/templates'
import { MobileTransactionsList } from '@/features/Transactions/ui/MobileTransactionsList/MobileTransactionsList'
import { AppRoutes } from '@/routes'
import { getUrl } from '@/shared/helpers/url'
import { useBalancesStore } from '@/store'
import { Flex } from 'antd'
import React, { useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useQuery } from '@tanstack/react-query'

export default function IndexPage() {
  const { selectedWallet } = useBalancesStore(useShallow((state) => ({ selectedWallet: state.selectedWallet, })))

  const queryOptions = useMemo(
    () => createTransactionsQueryOptions({ size: 5, solAddress: selectedWallet?.address, }, !!selectedWallet),
    [selectedWallet]
  )

  const { data: txs, isSuccess } = useQuery(queryOptions)

  return (
    <MobilePageTemplate>
      <div className="mobileContainerWithTabs">
        <Flex gap={24} vertical>
          <MobileTopBar />
          <TotalBalanceSlider />
          <MobileTransactionsList
            blockTitle="Events"
            blockExtraLink={getUrl(AppRoutes.EVENTS_PAGE, { pk: selectedWallet?.address.toString() || '' })}
            blockExtraTitle="View all"
            transactions={isSuccess ? txs : null}
            events={[]}
            withPadding
          />
          <MobileCards />
          <Assets withHeader />
        </Flex>
      </div>
    </MobilePageTemplate>
  )
}
